import * as React from 'react';
import uniqBy from 'lodash/uniqBy';
import { connectCurrentRefinements } from 'react-instantsearch-core';
import { Price } from '@grandvisionhq/common';
import { Tag } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useAlgoliaConfig } from '../../AlgoliaConfig.js';
import { getFacetOptionLabel } from '../../utils/get-facet-option-label.js';
import ClearRefinements from '../ClearRefinements/ClearRefinements.js';

const CurrentRefinements = ({ items: items1 , refine  })=>{
    const { facets  } = useAlgoliaConfig();
    const intl = useIntl();
    const uniqItems = React.useMemo(()=>uniqBy(items1, (item)=>item.attribute + item.label
        )
    , [
        items1
    ]);
    const refinementItems = React.useMemo(()=>{
        return uniqItems.reduce((result, item, i)=>{
            const facet = facets.find(({ attribute  })=>attribute === item.attribute
            );
            if (!facet || facet.hidden) {
                return result;
            }
            const element = /*#__PURE__*/ React.createElement(React.Fragment, {
                key: i
            }, isRangeRefinement(item) ? renderRange(item) : item.items ? renderItems(item.items, facet) : null);
            return [
                ...result,
                element
            ];
        }, []);
    }, [
        uniqItems
    ]);
    return refinementItems.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "current-refinements",
        "data-t": "current-refinements"
    }, refinementItems, /*#__PURE__*/ React.createElement(ClearRefinements, null)) : null;
    function renderItems(items, facet) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, items.map((item)=>/*#__PURE__*/ React.createElement("span", {
                key: item.label,
                className: "current-refinements__tag"
            }, /*#__PURE__*/ React.createElement(Tag, {
                onClick: ()=>refine(item.value)
            }, facet.showLabel && facet.labelKey && intl.hasLabel(facet.labelKey) && /*#__PURE__*/ React.createElement("span", {
                className: "current-refinements__label"
            }, intl.getLabel(facet.labelKey || facet.id), ":", ' '), getFacetOptionLabel(facet, item.label, intl).label))
        ));
    }
    function renderRange({ currentRefinement: { min , max  } , label , value  }) {
        return /*#__PURE__*/ React.createElement("span", {
            key: label,
            className: "current-refinements__tag"
        }, /*#__PURE__*/ React.createElement(Tag, {
            onClick: ()=>refine(value)
        }, /*#__PURE__*/ React.createElement(Price, {
            value: Math.round(min / 100),
            currency: intl.currency,
            centAmount: false
        }), ' – ', /*#__PURE__*/ React.createElement(Price, {
            value: Math.round(max / 100),
            currency: intl.currency,
            centAmount: false
        })));
    }
};
var CurrentRefinements$1 = connectCurrentRefinements(CurrentRefinements);
function isRangeRefinement(refinement) {
    const currentRefiment = refinement.currentRefinement;
    return currentRefiment.hasOwnProperty('min') || currentRefiment.hasOwnProperty('max');
}

export { CurrentRefinements, CurrentRefinements$1 as default };
//# sourceMappingURL=CurrentRefinements.js.map
